import { BaseServices, HttpMethod } from '@services/base'
import { GetDadosPessoaisResponse } from '@store/refinanciamento/dadosPessoais/types'

import { BridgeService } from './bridge'

export default (accessToken?: string) => {
  const pathname = process.env.REACT_APP_GET_POST_CUSTOMER_DATA as string
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST as string
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request<GetDadosPessoaisResponse>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}
